// Keep content below the fixed announcement + header
function syncHeaderOffset() {
  var announcement = document.querySelector('.announcement-bar');
  var header = document.querySelector('.header');
  var spacer = document.querySelector('.header-spacer');
  if (!header || !spacer) return;

  var announcementHeight = announcement ? announcement.offsetHeight : 0;
  header.style.top = announcementHeight + 'px';
  spacer.style.height = (announcementHeight + header.offsetHeight) + 'px';
}

document.addEventListener('DOMContentLoaded', function() {
  syncHeaderOffset();
  window.addEventListener('resize', syncHeaderOffset);
  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
    });
  }

  // Product image gallery
  const productThumbnails = document.querySelectorAll('.product__thumbnail');
  const productMainImage = document.getElementById('ProductMainImage');
  
  if (productThumbnails.length && productMainImage) {
    productThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const newSrc = this.src.replace('160', '800');
        productMainImage.src = newSrc;
        
        // Update active state
        productThumbnails.forEach(thumb => thumb.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // Cart quantity updates
  const quantityInputs = document.querySelectorAll('.cart-item__quantity-input');
  
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const key = this.dataset.itemKey;
      const quantity = this.value;
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        window.location.reload();
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  });

});